import { combineReducers } from 'redux'
import all from './get-all'
import assign from './assign'

const reducer = combineReducers({
  all,
  assign
})

export default reducer
